export const state = () => ({
  assistant: '',
  newChatRequestId: 0,
})

export const mutations = {
  setAssistant(currentState, assistant) {
    localStorage.assistant = JSON.stringify(assistant)
    currentState.assistant = localStorage.assistant
  },
  // Botão "Nova conversa" mora no header (pages/IA.vue), mas quem sabe
  // resetar a conversa é o componente de chat. Incrementar esse contador
  // dispara o watch em pages/IA/chat.vue sem acoplar os dois componentes.
  requestNewChat(currentState) {
    currentState.newChatRequestId++
  },
}
